import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeForbiddenFeature } from '../../../global/ducks/authenticated-slice';
import { ClearTcsmSessionStorage } from '../../../global/helpers/session-storage-helper';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { TcsmFeatures } from '../../../global/models/features-model';
import { unloadDependentState } from '../../account-info/features/dependents/dependents-slice';
import { unloadPersonState } from '../../account-info/features/personal-info/personal-info-slice';
import { unloadRelationshipState } from '../../account-info/features/relationships/relationships-slice';
import { unloadBillingAccounts } from '../features/billing-accounts/billing-accounts-slice';
import { unloadCompensationState } from '../features/compensation/compensation-history/compensation-history-slice';
import { unSetEmploymentState } from '../features/employment/employment-slice';
import { clearGroupState } from '../features/groups/groups-slice';
import { clearMidYearState } from '../features/mid-year/mid-year-slices';

export function useGroupsReset() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(removeForbiddenFeature(TcsmFeatures.GroupAdminSearch));
        dispatch(clearGroupState());
        dispatch(unloadBillingAccounts());
    }, []);
}

export function useGroupSearchReset(ignoreEmploymentState?: boolean, skipGroup?: boolean) {
	const dispatch = useDispatch();


	useEffect(() => {


		if (!ignoreEmploymentState) {
			dispatch(unSetEmploymentState());
		}

		dispatch(unloadCompensationState());
		dispatch(unloadPersonState(DemographicAppKeys.arc));
		dispatch(unloadRelationshipState(DemographicAppKeys.arc));
		dispatch(unloadDependentState(DemographicAppKeys.arc));
		dispatch(clearMidYearState());
		ClearTcsmSessionStorage(skipGroup);
	}, []);
}